<template>
  <div class="vx-card" id="create-remittance">
    <div class="vx-card__body">
      <form>
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <label class="vs-select--label">{{ $t("CategoryName") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="categoryName"
              :options="allDepartment"
              :loading="searchFlag"
              v-model="departmentUnitName"
              v-validate="{ required: true }"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('categoryName')"
              >{{ errors.first("categoryName") }}</span
            >
          </div>

          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
            <label class="vs-select--label datepicker-lb">{{
              $t("DeliveryDate")
            }}</label>
            <date-picker
              v-model="deliveryClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              v-validate="'required'"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              id="date-picker"
              :label="$t('DeliveryDate')"
              name="date"
            />
            <span class="text-danger text-sm" v-show="errors.has('date')">{{
              errors.first("date")
            }}</span>
          </div>
          <div class="vx-col lg:w-2/4 sm:w-1/2 w-full my-2">
            <vs-textarea
              :placeholder="$t('Description')"
              v-model="description"
              name="Description"
              :label="$t('Description')"
            />
          </div>
        </div>

        <div class="flex justify-end">
          <vs-button
            type="filled"
            @click.prevent="add"
            :disabled="!deliveryClock"
          >
            <span v-if="productSection">{{ $t("Edit") }}</span>
            <span v-else> {{ $t("Continue") }}</span>
          </vs-button>
        </div>
      </form>
      <hr class="my-3" />
      <form v-if="productSection">
        <div class="my-5">
          <div class="flex" v-has-permission="'CreatePurchaseRequestWithExcel'">
            <label class="custom-file-upload flex">
              <input
                type="file"
                id="file"
                ref="purchaseRequestElement"
                v-on:change="handlepurchaseRequestSelection()"
              />
              <div class="flex gap-2 items-center">
                <feather-icon
                  icon="PaperclipIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                <span>{{ $t("PurchaseOrderUpload") }}</span>
              </div>
              <span v-if="selectedPurchaseRequestFileName" class="file-name">{{
                selectedPurchaseRequestFileName
              }}</span>
            </label>
            <vs-button
              @click="uploadPackage()"
              class="bg_m_green float-right"
              v-if="purchaseRequestSelected"
              :disabled="serialUploadButtonDisabled"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("Submit") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row mr-1 mb-5 ml-8">
          <div class="md:w-1/2 w-full flex-shrink-0">
            <label class="vs-select--label">{{ $t("Product") }}</label>
            <treeselect
              v-model="model.stockId"
              name="stockid"
              :multiple="false"
              :placeholder="$t('SearchProduct')"
              :async="true"
              :load-options="loadOptions"
              v-validate="'required'"
              @select="onStockSelected"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="productName"
              name="productName"
              v-validate="'required'"
              :label="$t('ProductName')"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="modelNumber"
              name="modelNumber"
              v-validate="'required'"
              :label="$t('ModelNumber')"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <label class="vs-select--label">{{ $t("Unit") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="unit"
              :options="allUnits"
              v-model="unit"
              v-validate="'required'"
              dir="rtl"
            >
            </v-select>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="amount"
              name="amount"
              v-validate="'required'"
              :label="$t('Amounts')"
            />
          </div>
        </div>
        <div class="mt-5 w-full flex items-end mb-2 justify-end">
          <vs-button
            type="filled"
            :disabled="
              !amount ||
              !departmentUnitName ||
              !deliveryClock ||
              !productName ||
              !modelNumber
            "
            @click.prevent="addProduct"
            >{{ $t("Add") }}</vs-button
          >
        </div>
      </form>
    </div>
    <div v-if="pharchaseRequestItems" class="vx-row mx-3">
      <div class="vx-col w-full mb-base">
        <vs-table :data="productList" class="custom-tbl">
          <template slot="thead">
            <th style="width: 5%">#</th>
            <th style="width: 30%">{{ $t("ProductName") }}</th>
            <th style="width: 20%">{{ $t("ModelNumber") }}</th>
            <th style="width: 10%">{{ $t("Unit") }}</th>
            <th style="width: 10%">{{ $t("Amounts") }}</th>
            <th style="width: 30%">{{ $t("Action") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(product, i) in data">
              <vs-td>
                {{ i + 1 }}
              </vs-td>
              <vs-td>
                {{ product.productName }}
              </vs-td>
              <vs-td>
                {{ product.modelNumber }}
              </vs-td>
              <vs-td>
                {{ product.unitOfMeasures.name }}
              </vs-td>
              <vs-td>
                {{ product.count }}
              </vs-td>
              <vs-td>
                <div class="flex items-center gap-3 justify-center">
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deletePurchaseRequestItem(i)"
                    class="d-inline remove-btn flex-shrink-0"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-5 w-full flex items-end mb-2 justify-end">
          <vs-button type="filled" @click.prevent="submitForm">{{
            $t("Save")
          }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import { mapActions } from "vuex";
import { mapGetters } from "vuex/dist/vuex.common.js";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

const dict = {
  custom: {
    amount: {
      required: "لطفا مقدار کالا را وارد نمایید.",
    },
    categoryName: {
      required: "لطفا نام دپارتمان را وارد نمایید.",
    },
    date: {
      required: "لطفا تاریخ تحویل را وارد نمایید.",
    },
    productName: {
      required: "لطفا نام محصول را وارد نمایید.",
    },
    modelNumber: {
      required: "لطفا مدل نامبر را وارد نمایید.",
    },
    unit: {
      required: "لطفا واحد اندازه گیری را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
    Treeselect,

    DataGrid,
  },
  data() {
    return {
      purchaseRequestElement: null,
      selectedPurchaseRequestFileName: "",
      purchaseRequestSelected: false,
      serialUploadButtonDisabled: false,

      allDepartment: [],
      allUnits: [],
      productList: [],
      searchFlag: true,
      productSection: false,
      pharchaseRequestItems: false,
      model: {},
      productModel: {},
      modelNumber: "",
      itemCode: "",
      productName: "",
      deliveryClock: "",
      description: "",
      unit: null,
      departmentUnitName: null,
      amount: null,
      searchQueryNew: "",
      searchQueryOld: "",
      stockId: "",
      gridDataSource: {
        type: "app",
        service: "Credits/api/DetailAccountsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  mounted() {
    this.fetchUnits().then((r) => {
      this.allUnits = r;
    });
    this.fetchDepartment().then((r) => {
      this.allDepartment = r;
      this.searchFlag = false;
    });
  },
  methods: {
    ...mapActions({
      addPurchaseRequest: "purchaseRequest/createPurchaseRequest",
      fetchUnits: "unit/fetchList",
      fetchDepartment: "departman/departmanList",
      fetchSearch: "purchaseRequest/fetchSearch",
      createPurchaseRequestByExcel: "excel/createPurchaseRequestByExcel",
    }),
    handlepurchaseRequestSelection() {
      this.purchaseRequestElement = this.$refs.purchaseRequestElement.files[0];
      this.selectedPurchaseRequestFileName = this.purchaseRequestElement.name;
      this.purchaseRequestSelected = true;
    },
    uploadPackage() {
      this.serialUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.purchaseRequestElement);
      this.createPurchaseRequestByExcel({
        file: formData,
        departman: this.departmentUnitName.id,
        deliveryClock: this.deliveryClock,
        description: this.description ? this.description : "",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .finally(() => {
          this.serialUploadButtonDisabled = false;
          this.onFileUploadSuccess();
        });
    },
    onFileUploadSuccess() {
      this.$refs.purchaseRequestElement.value = null;
      this.$refs.serialFileElement.value = null;
      this.serialFileSelected = false;
      this.purchaseRequestSelected = false;
      this.selectedPurchaseRequestFileName = "";
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              console.log(r);
              r.data.forEach((element) => {
                options.push({
                  id: element.id,
                  label: element.name,
                  modelNumber: element.modelNumber,
                  itemCode: element.itemCode,
                });
              });

              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelected(data) {
      this.productName = data.label;
      this.modelNumber = data.modelNumber;
      this.itemCode = data.itemCode;
      this.model.stockId = null;
    },
    addProduct() {
      this.$validator.validateAll().then((result) => {
        const product = {
          productName: this.productName,
          modelNumber: this.modelNumber,
          itemCode: this.itemCode,
          unitOfMeasures: this.unit,
          unitOfMeasureId: this.unit.id,
          count: this.amount,
        };
        this.productList.push(product);
        (this.productName = " "),
          (this.modelNumber = " "),
          (this.itemCode = " "),
          (this.unit = null),
          (this.amount = null),
          (this.pharchaseRequestItems = true);
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (this.productList)
          this.model = {
            departmentId: this.departmentUnitName.id,
            deliveryClock: this.deliveryClock,
            description: this.description,
            purchaseItems: this.productList,
          };

        this.addPurchaseRequest(this.model)
          .then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "درخواست خرید مورد نظر ایجاد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.productList = [];
              this.$router.go(-1);
            });
          })
          .catch((e) => {
            this.productList = [];
          });
      });
    },
    add() {
      this.productSection = true;
    },
    deletePurchaseRequestItem(index) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then(() => {
        this.productList.splice(index, 1);
      });
    },
  },
};
</script>
<style>
.custom-file-upload {
  border: 1px solid #ccc;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
input[type="file"] {
  display: none;
}
</style>
